import { put } from '..';
import {
  StaffTicketNotificationPreferences,
  UserNotificationPreferences,
} from '../../constants/Types';

interface UpdateNotificationPreferencesRequest {
  enabledCategories?: UserNotificationPreferences['enabledCategories'];
  ticketNotificationPreferences?: StaffTicketNotificationPreferences;
}

const updateNotificationPreferences = (
  body: UpdateNotificationPreferencesRequest,
) => put('users/me/notification-preferences', body);

export default updateNotificationPreferences;
